export default {
  de: {
    add: 'Definition hinzufügen',
    definitions: 'Definitionen',
    newDefinition: 'Neue Berichtdefinition',
    statuses: 'Status',
    name: 'Name',
  },
};
